export function idKey(value) {
  return value == null || value === '' ? '' : String(value);
}

export function assistantLineKey(msgIdx, productId) {
  return `m${msgIdx}-p${idKey(productId)}`;
}

export function assistantAddonLineKey(msgIdx, productId, addonIndex) {
  return `m${msgIdx}-a${idKey(productId)}-${addonIndex}`;
}

export function assistantSuggestedLineKey(msgIdx, prodIndex, productId) {
  return `m${msgIdx}-s${prodIndex}-p${idKey(productId)}`;
}
